export const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/**
 * Extracts the first URL found in a given text string.
 * This is used to extract a URL to embed.
 */
export function extractFirstUrl(text?: string): string | null {
  if (!text) return null;
  const match = text.match(URL_REGEX);
  return match ? match[0] : null;
}
